import React from 'react';
import { WidgetsPanelWrapper } from './styled';

function WidgetsPanelPlaceholder() {

  return (
    <WidgetsPanelWrapper>
      <h3>Coming Soon</h3>
      <div>Composite Metrics combining multiple data points for faster and simplified analysis.</div>
    </WidgetsPanelWrapper>
  )

}

export default WidgetsPanelPlaceholder;
